import { render, staticRenderFns } from "./YourCourse.vue?vue&type=template&id=048600a8&scoped=true&"
import script from "./YourCourse.vue?vue&type=script&lang=js&"
export * from "./YourCourse.vue?vue&type=script&lang=js&"
import style0 from "./YourCourse.vue?vue&type=style&index=0&id=048600a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048600a8",
  null
  
)

export default component.exports